//@flow
import React from 'react';
class Dialog extends React.Component < * > {
  render() {
    return <div className="modal-dialog">
      <div className="modal-content">
        {this.props.children}
      </div>
    </div>
  }
}
class Header extends React.Component < * > {
  render() {
    return <div className={["modal-header",this.props.className].join(" ")}>{this.props.children}</div>
  }
}
class Title extends React.Component < * > {
  render() {
    return <div className={["modal-title",this.props.className].join(" ")}>{this.props.children}</div>
  }
}
class Body extends React.Component < * > {
  render() {
    return <div className={["modal-body",this.props.className].join(" ")}>{this.props.children}</div>
  }
}
class Footer extends React.Component < * > {
  render() {
    return <div className={["modal-footer",this.props.className].join(" ")}>{this.props.children}</div>
  }
}
class Modal extends React.Component < {
  show: boolean,
  children: * ,
  className ? : string | Array < string >
} > {
  static Footer = Footer;
  static Title = Title;
  static Header = Header;
  static Dialog = Dialog;
  static Body = Body;

  render() {
    const style = {
      display: this.props.show ? 'block' : 'none'
    }
    return <div>
  <div className="modal-backdrop"></div>
    <div
      className={['modal',this.props.show ? 'show':null,this.props.className].join(" ")}
      style={style}
      >{this.props.children}</div>
    </div>
  }
}

export default Modal;